<ng-container *ngIf="reference && supplier">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Mise à jour du fournisseur pour  {{reference.isbn}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      L'ISBN {{ reference.isbn }} - <strong>{{ reference.title }}</strong> 
      <span *ngIf="activeSupplierReference"> est associé au fournisseur {{ activeSupplierReference.supplier.name }}.</span>
      <span *ngIf="!activeSupplierReference"> est associé à aucun fournisseur.</span>
    </p>
    <p>
      Saissisez un prix de vente pour l'associer au fournisseur {{ supplier.name }}.
    </p>
    <div class="form-group">
      <label>Prix</label>
      <div class="input-group">
        <input text="number" class="form-control" [(ngModel)]="price" step="0.01" min="0" max="9999"  />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.close()">Annuler</button>
    <button type="button" class="btn btn-primary" [attr.disabled]="newSupplierReferenceRequest.price == 0 ? 'disabled' : null" (click)="createSupplierReference()">Associer</button>
  </div>
</ng-container>